export const KNOWLEDGE_SYNC_PATH_NAME = 'knowledge-sources';

export const INTEGRATION_PROVIDERS = {
  LINEAR: 'linear',
  JIRA: 'jira',
  SERVICENOW: 'servicenow',
  GITHUB_ISSUES: 'github_issues',
  CONFLUENCE: 'confluence',
  NOTION: 'notion',
  GOOGLE_DRIVE: 'google_drive',
  BOX: 'box',
  GLEAN: 'glean',
  WIZ: 'wiz',
  HACKERONE: 'hackerone',
  XPANSE: 'xpanse',
  CROWDSTRIKE: 'crowdstrike',
  CROWDSTRIKE_NG_SIEM: 'crowdstrikeNgSiem',
  CORTEX_XSIAM: 'cortexXsiam',
  SPLUNK: 'splunk',
  TORQ: 'torq',
  BUGCROWD: 'bugcrowd',
  UPWIND: 'upwind',
  JENKINS: 'jenkins',
  SLACK: 'slack',
  MICROSOFT_TEAMS: 'microsoftTeams',
  PAGERDUTY: 'pagerduty',
  GENERIC_WAF: 'genericWaf',
  AWS_SECURITY_GROUP: 'awsSecurityGroup',
  GCP_FIREWALL: 'gcpFirewall',
  AZURE_NSG: 'azureNsg',
  GENERIC_CONFIG: 'genericConfig',
  AWS: 'aws',
  GCP: 'gcp',
  AZURE: 'azure',
} as const;

export type IntegrationProviderType =
  (typeof INTEGRATION_PROVIDERS)[keyof typeof INTEGRATION_PROVIDERS];

export const TICKETING_PROVIDERS = {
  LINEAR: 'linear',
  JIRA: 'jira',
  SERVICENOW: 'servicenow',
  GITHUB_ISSUES: 'github_issues',
} as const;

export type TicketingProviderType =
  (typeof TICKETING_PROVIDERS)[keyof typeof TICKETING_PROVIDERS];

export const SIEM_PROVIDERS = {
  SPLUNK: 'splunk',
  CROWDSTRIKE_NG_SIEM: 'crowdstrikeNgSiem',
  CORTEX_XSIAM: 'cortexXsiam',
} as const;

export type SiemProviderType =
  (typeof SIEM_PROVIDERS)[keyof typeof SIEM_PROVIDERS];

export const WAF_PROVIDERS = {
  GENERIC_WAF: 'genericWaf',
} as const;

export type WafProviderType =
  (typeof WAF_PROVIDERS)[keyof typeof WAF_PROVIDERS];

export const NETWORK_CONTROL_PROVIDERS = {
  AWS_SECURITY_GROUP: 'awsSecurityGroup',
  GCP_FIREWALL: 'gcpFirewall',
  AZURE_NSG: 'azureNsg',
} as const;

export type NetworkControlProviderType =
  (typeof NETWORK_CONTROL_PROVIDERS)[keyof typeof NETWORK_CONTROL_PROVIDERS];

export const CONFIG_CONTROL_PROVIDERS = {
  GENERIC_CONFIG: 'genericConfig',
} as const;

export type ConfigControlProviderType =
  (typeof CONFIG_CONTROL_PROVIDERS)[keyof typeof CONFIG_CONTROL_PROVIDERS];

export const IPS_CONTROL_PROVIDERS = {
  GENERIC_IPS: 'genericIps',
} as const;

export type IpsControlProviderType =
  (typeof IPS_CONTROL_PROVIDERS)[keyof typeof IPS_CONTROL_PROVIDERS];

export const PREVENTION_PROVIDERS = {
  ...WAF_PROVIDERS,
  ...NETWORK_CONTROL_PROVIDERS,
  ...CONFIG_CONTROL_PROVIDERS,
  ...IPS_CONTROL_PROVIDERS,
} as const;

export type PreventionProviderType =
  (typeof PREVENTION_PROVIDERS)[keyof typeof PREVENTION_PROVIDERS];

export const CLOUD_PROVIDERS = {
  AWS: 'aws',
  GCP: 'gcp',
  AZURE: 'azure',
} as const;

export type CloudProviderType =
  (typeof CLOUD_PROVIDERS)[keyof typeof CLOUD_PROVIDERS];

export const MESSAGING_PROVIDERS = {
  SLACK: 'slack',
  MICROSOFT_TEAMS: 'microsoftTeams',
  PAGERDUTY: 'pagerduty',
} as const;

export type MessagingProviderType =
  (typeof MESSAGING_PROVIDERS)[keyof typeof MESSAGING_PROVIDERS];

export const KNOWLEDGE_SYNC_PROVIDERS = {
  CONFLUENCE: 'confluence',
  NOTION: 'notion',
  GOOGLE_DRIVE: 'google_drive',
  BOX: 'box',
} as const;

export type KnowledgeSyncProviderType =
  (typeof KNOWLEDGE_SYNC_PROVIDERS)[keyof typeof KNOWLEDGE_SYNC_PROVIDERS];

export const INTEGRATION_AUTH_MODES = {
  OAUTH: 'oauth',
  CCG: 'ccg',
} as const;

export const SYNC_STATUS = {
  INITIALIZING: 'INITIALIZING',
  ACTIVE: 'ACTIVE',
  PROCESSING: 'PROCESSING',
  IDLE: 'IDLE',
  ERRORED: 'ERRORED',
  DISABLED: 'DISABLED',
} as const;

export type SyncStatusType = (typeof SYNC_STATUS)[keyof typeof SYNC_STATUS];

export const SCOPE_TYPE = {
  CONTAINER: 'CONTAINER',
  ITEM: 'ITEM',
} as const;

export type ScopeTypeValue = (typeof SCOPE_TYPE)[keyof typeof SCOPE_TYPE];

export const INGESTION_LINK_STATUS = {
  ACTIVE: 'ACTIVE',
  SUPERSEDED: 'SUPERSEDED',
  PENDING_DELETE: 'PENDING_DELETE',
  DELETED: 'DELETED',
} as const;

export type IngestionLinkStatusType =
  (typeof INGESTION_LINK_STATUS)[keyof typeof INGESTION_LINK_STATUS];

export const CONTENT_ITEM_STATUS = {
  ACTIVE: 'ACTIVE',
  DELETED: 'DELETED',
} as const;

export type ContentItemStatusType =
  (typeof CONTENT_ITEM_STATUS)[keyof typeof CONTENT_ITEM_STATUS];
